import { FormItemType } from "../../../UI/view/component-map";
import { FormView } from "../../../UI/view/form-view";
import { DewarCustomerSelectList2 } from "../../Customers/customer-dewar-list";

export const dewarRulesCreateForm = (mode, fromCustDetails) => ({
  modalSize: 'xl',
  title: 'Create Dewar Rule',
  addTemplate: (state) => {
    if (fromCustDetails) {
      return {
        cst: state.dewarcustomers?.current?.data?.site,
      };
    }
  },
  items: [
    {
      type: FormItemType.fieldset,
      label: 'Dewar Rule Details',
      items: [
        {
          type: FormItemType.labelField,
          name: 'customerName',
          label: 'Customer Name',
          computedValue: (getValues, _, watch) => watch('customerName') ?? watch('cst'),
          hideIf: () => mode === 'create' && !fromCustDetails,
        },
        {
          type: FormItemType.boundingBox,
          hideIf: () => mode === 'update' || fromCustDetails,
          height: 300,
          items: [
            {
              type: FormItemType.customField,
              style: { height: '100%', paddingBottom: 40 },
              required: true,
              name: 'cst',
              label: 'Select Dewar Customer',
              component: DewarCustomerSelectList2,
            },
          ]
        },
        {
          type: FormItemType.row,
          items: [
            {
              name: 'ruleType',
              label: 'Rule Type',
              type: FormItemType.select,
              onChange: ({ getValues, editTableProps, evt, setValue }) => {
                const val = evt.target.value;
                if (val == 'Price Warning Exclusion') {
                  const today = new Date();
                  const add6Months = new Date();
                  add6Months.setMonth(add6Months.getMonth() + 6);
                  setValue('value', 1);
                  setValue('effectiveDate', today);
                  setValue('expiresDate', add6Months);
                }
              },
              options: [
                { id: null, text: '' },
                { id: 'Free Days', text: 'Free Days' },
                { id: 'Bypass Customer Earned Income', text: 'Bypass Customer (Earned Income)' },
                { id: 'Volume Cap', text: 'Volume Cap (Between Effective and Expired Dates)' },
                { id: 'Dewar Rent Billing Email', text: 'Dewar Rental Billing Email Address' },
                { id: 'Price Warning Exclusion', text: 'Price Warning Exclusion' },
                { id: 'Override Emergency Order Placement Hours', text: 'Override Emergency Order Placement Hours' },
                { id: '(CBT) Helium Surcharge Exemption', text: '(CBT) Helium Surcharge Exemption' },
                { id: '(CBT) Delivery Fee', text: '(CBT) Delivery Fee' },
                { id: 'Bypass Customer Rent (CBT)', text: 'Bypass Customer Rent (CBT)' }
              ],
              required: true
            },
            {
              name: 'value',
              label: 'Value',
              required: true
            },
          ]
        },
        {
          type: FormItemType.row,
          items: [
            {
              name: 'effectiveDate',
              label: 'Date Rule Effective',
              type: FormItemType.date,
              required: true
            },
            {
              name: 'expiresDate',
              label: 'Date Rule Expires',
              type: FormItemType.date,
              required: true
            },
          ]
        },

        {
          type: FormItemType.collapsePanel,
          label: 'JDE Information',
          hide: () => mode !== 'create',
          items: [
            {
              type: FormItemType.row,
              items: [
                {
                  name: 'customerName',
                  label: 'Customer Name',
                  type: FormItemType.labelField,
                },
                {
                  name: 'city',
                  label: 'City',
                  type: FormItemType.labelField,
                },
                {
                  name: 'state',
                  label: 'State',
                  type: FormItemType.labelField,
                },
                {
                  name: 'zip',
                  label: 'Zip',
                  type: FormItemType.labelField,
                }
              ]
            }
          ]
        },
      ]
    }

  ]
}) as FormView;
